import { Container, Content, DialogContainerHeading, CurrentStep, SeparationLines, CustomSubmitButtonContainer, CustomSubmitButton } from "./styles";
import { Download } from "@mui/icons-material";
import { motion } from "framer-motion";
import { middleLeftAnimationProps, quickLeftAnimationProps } from "../../../functionallity/animationProps";
import EastOrWestButton from '../../../base/Buttons/EastOrWestButton/EastOrWestButton';
import { COLORS } from "../../../../values/colors";

interface DialogContainerProps {
    step: string;
    heading: string;
    content: string;
    hasButton?: boolean;
    onButtonClick?: () => void;
    onBack?: () => void;
    onNext?: () => void;
    isLastStep?: boolean;
    isFinished?: boolean;
    isFirstStep?: boolean;
}

const DialogContainer = ({ step, heading, content, hasButton, onButtonClick, onBack, onNext, isLastStep, isFinished = false, isFirstStep }: DialogContainerProps) => {
    return (
        <Container>
            <motion.div {...quickLeftAnimationProps}>
                <CurrentStep lang="de">{step}</CurrentStep>
                <DialogContainerHeading lang="de">{heading}</DialogContainerHeading>
            </motion.div>
            <SeparationLines />
            <motion.div {...middleLeftAnimationProps}>
                <Content><div dangerouslySetInnerHTML={{ __html: content }} /></Content>
                {hasButton && (
                    <CustomSubmitButtonContainer>
                        <CustomSubmitButton text="Download" onClick={onButtonClick} icon={<Download />} />
                    </CustomSubmitButtonContainer>
                )}
            </motion.div>
            <SeparationLines />
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', backgroundColor: COLORS.gray, marginTop: '2rem' }}>
                <EastOrWestButton east={false} onClick={onBack} text="Zurück" enabled={!isFirstStep} />
                <EastOrWestButton east={true} text={'Weiter'} onClick={onNext} enabled={!isFinished}/>
            </div>
        </Container>
    );
};

export default DialogContainer;
